// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames/bind';
import moment from 'moment';

import { statuses, paymentTypes, carrierId } from '../../config/types';
import shop from '../../images/shop.png';
import car from '../../images/car.png';
import Button from '../Button/Button';
import Loader from '../Loader/Loader';
import { downloadExtraLabelService, downloadWelcomePackService } from
  '../../pages/account/components/AccountTab/components/OrderFull/store/service';
import { CHARITY } from '../../config/constants';
import styles from './styles';

const statusApplied = [7, 13, 15];

class OrderLite extends Component {
  state = {};

  static propTypes = {
    classes: PropTypes.object,
    order: PropTypes.shape({
      OrderID: PropTypes.number,
      PaymentToCharity: PropTypes.number,
      PaymentType: PropTypes.number,
      OrderValue: PropTypes.number,
      OrderStatus: PropTypes.number,
      SubmittedOn: PropTypes.string,
      HomeCollection: PropTypes.number,
      EligibleForHomePickup: PropTypes.bool,
      CarrierId: PropTypes.number,
    }),
  };

  static defaultProps = {
    classes: {},
    order: {
      OrderID: 0,
      PaymentToCharity: 0,
      PaymentType: 2,
      OrderValue: 0,
      OrderStatus: 0,
      // ISO, so the value does not depend on American parsing rules to come
      // back out as the day it went in.
      SubmittedOn: new Date().toISOString(),
      HomeCollection: 0,
      EligibleForHomePickup: false,
      CarrierId: 2,
    },
  };

  renderTop = () => {
    const { classes, order } = this.props;
    const background = statusApplied.includes(order.OrderStatus)
      ? classes.paid
      : classes.processing;

    return (
      <Link
        className={classes.mainLink}
        to={{
          pathname: `/account/orders/full-order/${order.OrderID}`,
          state: { id: order.OrderID }
        }}
      >
        <div className={classNames(classes.topContainer, background)}>
          <span className={classes.orderIdText}>{`ORDER ID: ${order.OrderID}`}</span>
          <div className={classes.dateTimeContainer}>
            <span>{this.transformDate(order.SubmittedOn)}</span>
          </div>
        </div>
      </Link>
    );
  }

  transformDate = (date) => {
    return moment(new Date(date)).format('DD/MM/YYYY, h:mm A');
  }

  onPressExtraLabel = () => {
    const CustomerId = localStorage.getItem('loggedID');
    const Token = localStorage.getItem('token');
    const { order } = this.props;
    const downloadExtraLabelLink = downloadExtraLabelService({
      CustomerId,
      Token,
      OrderId: order.OrderID,
    });
    return downloadExtraLabelLink;
  }

  onPressWelcomePack = () => {
    const CustomerId = localStorage.getItem('loggedID');
    const Token = localStorage.getItem('token');
    const { order } = this.props;
    const downloadWelcomePackLink = downloadWelcomePackService({
      CustomerId,
      Token,
      OrderId: order.OrderID,
    });
    return downloadWelcomePackLink;
  }

  renderDeliveryType = (isDrop) => {
    const { classes, order } = this.props;
    const title = isDrop
      ? 'Find a drop off location'
      : 'Arrange a collection';
    const description = isDrop
      ? (order.CarrierId === carrierId.Evri
        ? '10000 Evri'
        : '5000 Collect+').concat(' locations nationwide')
      : 'Will collect from home or work';
    const imageSrc = isDrop ? shop : car;
    const imageStyle = isDrop ? classes.shopImage : classes.carImage;
    const url = isDrop
      ? order.CarrierId === carrierId.Evri
        ? `/account/orders/nearest-postcode/${order.OrderID}`
        : 'https://www.collectplus.co.uk/find-a-store'
      : `/account/orders/arrange-collection/${order.OrderID}`;

    let targetAttributeValue = '_self';
    if (order.CarrierId === carrierId['Collect+']) {
      targetAttributeValue = '_blank';
    }


    return (
      <Link
        className={classes.mainLink}
        to={{
          pathname: url,
          state: { id: order.OrderID }
        }}
        target={targetAttributeValue}
      >
        <div className={classes.findLocationContainer}>
          <img
            className={imageStyle}
            src={imageSrc}
            alt={'shop'}
          />
          <div className={classes.textFindLocationContainer}>
            <span className={classes.textFindLocation}>{title}</span>
            <span className={classes.textHermes}>{description}</span>
          </div>
        </div>
      </Link>
    );
  }

  renderArrangeCollection = (tradeCustomer) => {
    const { order, classes } = this.props;
    if (order.HomeCollection) {
      return (
        <div>
          <div className={classes.findLocationContainer}>
            <span className={classes.arrangeCollectionTitle}>COLLECTION ARRANGED</span>
          </div>
          {!tradeCustomer && <p className={classes.sliderText}>OR</p>}
        </div>
      );
    }
    return this.renderDeliveryType();
  }

  renderDropOffParcel = () => {
    return this.renderDeliveryType(true);
  }

  render() {
    const { classes, order } = this.props;
    const bottomText1 = 'Each box you send needs a unique label.';
    const bottomText2 = 'Generate extra labels clicking on the blue button.';
    const SHIPMENT_EXPIRED = 11;
    const isShipmentExpired = order.OrderStatus === SHIPMENT_EXPIRED;
    const paymentType = paymentTypes[order.PaymentToCharity ? CHARITY : order.PaymentType];
    const tradeCustomer = JSON.parse(localStorage.getItem('TradeCustomer'));

    return (
      <div className={classes.mainContainer}>
        {this.renderTop()}
        <div className={classes.bottomContainer}>
          <div className={classes.statusAndLabelContainer}>
            <div className={classes.infoContainer}>
              <span>
                {'PAYMENT TYPE - '}
                <span className={classes.boldValues}>{paymentType}</span>
              </span>
              <span>
                {'VALUE - '}
                <span>&#163; </span>
                <span className={classes.boldValues}>
                  {order.OrderValue.toFixed(2)}
                </span>
              </span>
              <span>
                {'STATUS - '}
                <span className={classes.boldValues}>{statuses[order.OrderStatus]}</span>
              </span>
            </div>
            {!statusApplied.includes(order.OrderStatus)
              && (
                <div className={classes.linkButtonsContainer}>
                  <base target={'_blank'} />
                  <a className={classes.linkButton} href={this.onPressExtraLabel()}>
                    <Button text={'extra label'} />
                  </a>
                  <a className={classes.linkButton} href={this.onPressWelcomePack()}>
                    <Button text={'welcome pack'} />
                  </a>
                </div>)}
          </div>
          <span className={classes.bottomText}>{bottomText1}</span>
          <span className={classes.bottomText}>{bottomText2}</span>
          {
            order
              ? (
                <div>
                  {((!isShipmentExpired && order.EligibleForHomePickup) || !!tradeCustomer)
                    && this.renderArrangeCollection(tradeCustomer)}
                  {!tradeCustomer && this.renderDropOffParcel()}
                </div>
              )
              : <div className={classes.loaderContainer}><Loader /></div>
          }
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(OrderLite);
